import {
  FocusContext,
  getCurrentFocusKey,
  setFocus,
} from '@noriginmedia/norigin-spatial-navigation'
import React, { useCallback } from 'react'
import { useHybridFocusable } from '../../../hooks/useHybridFocusable'
import ChangeStationCarouselItem from './ChangeStationCarouselItem'
import type { ChangeStationCarouselProps } from './types'

const STATION_ITEM_FOCUS_KEY_PREFIX = 'station-'

export default function ChangeStationCarousel({
  collection,
  onStationSelected,
}: ChangeStationCarouselProps) {
  const handleItemArrowPress = useCallback(
    (direction: string) => {
      if (collection && collection.length > 1) {
        const currentFocusKey = getCurrentFocusKey()

        if (
          currentFocusKey &&
          currentFocusKey.startsWith(STATION_ITEM_FOCUS_KEY_PREFIX)
        ) {
          const currentStationId = currentFocusKey.replace(
            STATION_ITEM_FOCUS_KEY_PREFIX,
            ''
          )
          const currentIndex = collection.findIndex(
            (s: any) => s.pbs_id === currentStationId
          )

          if (currentIndex !== -1) {
            let targetIndex = -1

            if (direction === 'down' && currentIndex < collection.length - 1) {
              targetIndex = currentIndex + 1
            }

            if (direction === 'up' && currentIndex > 0) {
              targetIndex = currentIndex - 1
            }

            if (targetIndex >= 0 && targetIndex < collection.length) {
              const targetStation = collection[targetIndex]
              const targetFocusKey = `${STATION_ITEM_FOCUS_KEY_PREFIX}${targetStation.pbs_id}`
              setFocus(targetFocusKey)

              return false
            }
          }
        }
      }

      return true
    },
    [collection]
  )

  const { ref, focusKey } = useHybridFocusable({
    focusKey: 'STATIONS_CAROUSEL_CONTAINER',
  })

  return (
    <div className="carousel-container">
      <FocusContext.Provider value={focusKey}>
        <div className="station-carousel-container" ref={ref}>
          {collection &&
            collection.length &&
            collection.map((station, i) => {
              return (
                <ChangeStationCarouselItem
                  key={`${STATION_ITEM_FOCUS_KEY_PREFIX}${i}`}
                  focusKey={`${STATION_ITEM_FOCUS_KEY_PREFIX}${station.pbs_id}`}
                  station={station}
                  onArrowPress={handleItemArrowPress}
                  onEnterPress={() => {
                    onStationSelected(station)
                  }}
                />
              )
            })}
        </div>
      </FocusContext.Provider>
    </div>
  )
}
